export const Domain = "https://sign.kaveret.biz";